import { FormControlLabel, MenuItem, Switch } from '@mui/material';
import { Menu } from '@mui/material';

interface SettingsMenuProps {
  anchorEl: HTMLElement | null;
  handleMenuClose: () => void;
  settings: any;
  setSettings: (settings: any) => void;
  settingsLabel: any;
}

export const SettingsMenu = ({
  anchorEl,
  handleMenuClose,
  settings,
  setSettings,
  settingsLabel,
}: SettingsMenuProps): JSX.Element => {
  const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSettings({ ...settings, [event.target.name]: event.target.checked });
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}>
      {Object.keys(settings)
        .filter((key) => key !== 'showOverview')
        .map((key) => (
          <MenuItem key={key} sx={{ paddingLeft: '0px', paddingRight: '16px' }}>
            <FormControlLabel
              labelPlacement="start"
              control={<Switch checked={settings[key]} name={key} onChange={handleToggleChange} size="small" />}
              label={settingsLabel[key]}
              slotProps={{
                typography: {
                  sx: {
                    width: '188px',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    paddingRight: '16px',
                  },
                },
              }}
            />
          </MenuItem>
        ))}
    </Menu>
  );
};

export default SettingsMenu;
